import * as yup from "yup";
import i18n from "i18next";

export const feedbackSchema = yup.object().shape({
  type: yup.string().required(i18n.t("Choose_Type")),
  feedback: yup.string().required(i18n.t("Write_Feedback_Text")),
});
